<template>
  <v-dialog v-model="active" persistent max-width="350">
    <ValidationObserver ref="obs" v-slot="{ passes }">
      <v-card>
        <v-card-title> Selecciona tu extensión </v-card-title>
        <v-card-text>
          <ValidationProvider
            name="extensión"
            rules="required"
            v-slot="{ errors }"
          >
            <v-autocomplete
              :disabled="isLoadingExtensionItems"
              :items="extesionItems"
              required
              filled
              rounded
              class="rounded-small"
              dense
              label="Extensión"
              name="Extensión"
              prepend-inner-icon="mdi-database"
              color="info"
              v-model="extesionSelected"
              :error-messages="errors"
            ></v-autocomplete>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closedialog('cerrar')"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="passes(closedialog('set'))"
              >Seleccionar</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  props: {
    active: Boolean,
  },

  data() {
    return {
      isLoading: true,
      isLoadingExtensionItems: false,
      extesionItems: [],
      extesionSelected: null,
    };
  },

  created() {
    this.getExtension();
  },

  methods: {
    async getExtension() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listextensOnline`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.extesionItems = res.data;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error(
            "No se pudo obtener listado de extensiones.",
            "¡Error!"
          );
        })
        .finally(() => {
          this.isLoadingExtensionItems = false;
          this.isLoading = false;
        });
    },

    closedialog(value) {
      this.$emit("dialog:change", value, this.extesionSelected);
    },
  },
};
</script>
